<script setup>
  import { defineProps, defineEmits, computed } from 'vue'

  const baseTypeList = [
    "normal",
    "fire",
    "fighting",
    "water",
    "flying",
    "grass",
    "poison",
    "electric",
    "ground",
    "psychic",
    "rock",
    "ice",
    "bug",
    "dragon",
    "ghost",
    "dark",
    "steel",
    "fairy"
  ];

  const props = defineProps({
    modelValue: String,
    showNone: {
      tye: Boolean,
      default: false,
    },
    noneIsAny: {
      type: Boolean,
      default: false,
    }
  });

  const emit = defineEmits(["update:modelValue", "change"]);

  const selectedTypeClass = computed(() =>{
    if (props.modelValue == '-'){
      return ''
    }
    return 'bg-type-'+props.modelValue;
  })

  const typeList = computed(() =>{
    let tl = [...baseTypeList];
    if (props.showNone){
      tl.splice(0, 0, '-');
    }
    return tl
  })


  const typeName = (typeId) => {
    if (typeId == '-'){
      return props.noneIsAny ? "Any" : "None"
    }
    return typeId.slice(0,1).toUpperCase() + typeId.slice(1);
  }

  const onChange = (newValue) => {
    emit('update:modelValue', newValue);
    emit('change', newValue);
  }

</script>
<template>
  <select
    :class="[
      'font-bold',
      selectedTypeClass
    ]"
    :value="modelValue"
    @input="onChange($event.target.value)"
  >
    <option
      v-for="pType in typeList"
      :key="pType"
      :value="pType"
    >{{ typeName(pType) }}</option>
  </select>
</template>
